import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { returnUrlOf } from '../../../services/session.guard';
import { SessionState, SessionStore, SignInError } from '../../../services/session.store';

const SIGN_IN_ERROR_MESSAGES: Record<SignInError, string> = {
  invalid: 'Nieprawidłowy e-mail lub hasło.',
  locked: 'Zbyt wiele nieudanych prób. Spróbuj ponownie za kilkanaście minut.',
  failed: 'Nie udało się zalogować. Spróbuj ponownie.'
};

// Outside the shell: app.html renders the top menu and the sidenav only when signed in.
// No page store of its own — the app-wide SessionStore is the state here
@Component({
  selector: 'sign-in',
  templateUrl: './sign-in.page.html',
  styleUrl: './sign-in.page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe]
})
export class SignInPage {
  readonly state$: Observable<SessionState>;

  readonly passwordInput = viewChild.required<ElementRef<HTMLInputElement>>('password');

  constructor(
    private store: SessionStore,
    private route: ActivatedRoute,
    private router: Router,
    private destroyRef: DestroyRef
  ) {
    this.state$ = this.store.state$;
  }

  errorMessage(error: SignInError): string {
    return SIGN_IN_ERROR_MESSAGES[error];
  }

  // Enter submits the form natively; the handler owns the rest
  onSubmit(event: Event, email: string, password: string, rememberMe: boolean): void {
    event.preventDefault();

    const trimmedEmail = email.trim();

    if (!trimmedEmail || !password || this.store.state.signingIn) {
      return;
    }

    this.store.signIn(trimmedEmail, password, rememberMe).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      if (this.store.state.signInError) {
        // the typed password goes with the failure; the e-mail stays
        const input = this.passwordInput().nativeElement;
        input.value = '';
        input.focus();
        return;
      }

      this.router.navigateByUrl(returnUrlOf(this.route.snapshot.queryParamMap.get('returnUrl')));
    });
  }
}
